import React, { useEffect, useState } from 'react';
import imageMetadata from './ImageMetadata';
import '../styles.css';

const Sidebar = ({ currentImage, activeView, onViewChange }) => {
  const [showInfo, setShowInfo] = useState(true);
  const [isMobilePanelOpen, setIsMobilePanelOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsMobilePanelOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleTitleClick = () => {
    setShowInfo(!showInfo);
  };

  const renderImageInfo = () => {
    if (!currentImage || !imageMetadata[currentImage]) return null;

    const { film, camera, lens } = imageMetadata[currentImage];

    return (
      <div className="image-info-box">
        <h2>Photo Details</h2>
        {camera && (
          <div className="film-info">
            <p><strong>Camera</strong></p>
            <p>{camera}</p>
          </div>
        )}
        {lens && (
          <div className="film-info">
            <p><strong>Lens</strong></p>
            <p>{lens}</p>
          </div>
        )}
        {film && (
          <div className="film-info">
            <p><strong>Film Stock</strong></p>
            <img src={`films/${film}.webp`} alt={film} className="film-image" loading="lazy" decoding="async" />
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <div className="mobile-top-header" aria-hidden="true">
        <h1>Lex Bolt</h1>
        <p><i>Shot on film</i></p>
      </div>

      <div className="mobile-left-rail" aria-hidden="true" />

      <button
        className="mobile-sidebar-handle"
        onClick={() => setIsMobilePanelOpen(true)}
        aria-label="Open film stock panel"
        aria-expanded={isMobilePanelOpen}
      >
        <span className="dot" />
        <span className="dot" />
        <span className="dot" />
      </button>

      <div
        className={`sidebar-backdrop ${isMobilePanelOpen ? 'open' : ''}`}
        onClick={() => setIsMobilePanelOpen(false)}
        aria-hidden="true"
      />

      <div
        className={`sidebar ${isMobilePanelOpen ? 'mobile-open' : ''}`}
        onClick={(event) => event.stopPropagation()}
      >
        <div className="sidebar-topbar">
          <button
            className="mobile-close"
            onClick={() => setIsMobilePanelOpen(false)}
            aria-label="Close film stock panel"
          >
            ×
          </button>
        </div>
        <button className="site-title" onClick={handleTitleClick}>Lex Bolt</button>
        <p className="site-tagline"><i>Shot on film</i></p>
        <div className="view-switch" role="tablist" aria-label="Layout">
          <button
            className={`view-button ${activeView === 'carousel' ? 'active' : ''}`}
            onClick={() => {
              onViewChange('carousel');
              setIsMobilePanelOpen(false);
            }}
            role="tab"
            aria-selected={activeView === 'carousel'}
          >
            Featured
          </button>
          <button
            className={`view-button ${activeView === 'gallery' ? 'active' : ''}`}
            onClick={() => {
              onViewChange('gallery');
              setIsMobilePanelOpen(false);
            }}
            role="tab"
            aria-selected={activeView === 'gallery'}
          >
            Archive
          </button>
        </div>
        {showInfo && renderImageInfo()}
      </div>
    </>
  );
};

export default Sidebar;
